(() => {
  document.addEventListener('click', event => {
    const cartLink = event.target.closest('#cart-drawer-toggle');
    if (cartLink && event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
      const drawer = document.getElementById('Cart-Drawer');
      if (drawer && typeof drawer.open === 'function') {
        event.preventDefault();
        event.stopImmediatePropagation();
        drawer.open();
        return;
      }
    }
    const link = event.target.closest('a[href*="view=box-overview"]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(link.href);
  }, true);
  let scheduled = false;
  let bundleModels;
  const catalogLoads = new Map();
  const selectedColors = new Map();
  const loadCategory = container => {
    const categoryId = container.dataset.categoryId;
    const sdk = window.gbbSdk?.[bundleModels.offer_id];
    if (!categoryId || !sdk?.category?.f?.fetchAllProducts) return false;
    const load = catalogLoads.get(categoryId);
    if (load) return load === 'complete';
    if (!container.querySelector('.gbbProductItem[data-product-id]')) return false;
    catalogLoads.set(categoryId, 'loading');
    sdk.category.f.fetchAllProducts([categoryId]).then(result => {
      catalogLoads.set(categoryId, result?.ok ? 'complete' : 'failed');
      schedule();
    }).catch(() => {
      catalogLoads.set(categoryId, 'failed');
    });
    return false;
  };
  const groupBundleCards = () => {
    const source = document.getElementById('rodier-bundle-models');
    if (!source) return;
    if (!bundleModels) {
      try { bundleModels = JSON.parse(source.textContent); } catch { return; }
    }
    if (!bundleModels.enabled) return;
    const models = new Map(bundleModels.models.map(model => [String(model.id), model]));
    document.querySelectorAll('.gbbProductsContainer').forEach(container => {
      if (!loadCategory(container)) return;
      const groups = new Map();
      container.querySelectorAll('.gbbProductItem[data-product-id]').forEach(card => {
        const model = models.get(card.dataset.productId);
        if (!model) return;
        const key = String(model.group);
        if (!groups.has(key)) groups.set(key, []);
        groups.get(key).push({card, model});
      });
      groups.forEach(entries => {
        if (entries.length < 2) return;
        const signature = entries.map(entry => entry.card.dataset.productId).join(',');
        if (entries.every(entry => entry.card.dataset.rodierColorSignature === signature && entry.card.querySelector('.rodier-box-color select'))) return;
        const selectionKey = container.dataset.categoryId + ':' + entries[0].model.group;
        let selected = entries.find(entry => entry.card.dataset.productId === selectedColors.get(selectionKey)) || entries.find(entry => !entry.card.classList.contains('rodier-box-color-hidden')) || entries[0];
        entries.forEach(entry => {
          const {card} = entry;
          card.querySelector('.rodier-box-color')?.remove();
          card.dataset.rodierColorSignature = signature;
          card.classList.toggle('rodier-box-color-hidden', entry !== selected);
          const label = document.createElement('label');
          label.className = 'rodier-box-color';
          const text = document.createElement('span');
          text.textContent = bundleModels.label;
          const select = document.createElement('select');
          select.setAttribute('aria-label', bundleModels.label);
          if (!selectedColors.has(selectionKey)) {
            const placeholder = new Option(bundleModels.label, '', true, true);
            placeholder.disabled = true;
            select.append(placeholder);
          }
          entries.forEach(choice => {
            const option = document.createElement('option');
            option.value = choice.card.dataset.productId;
            option.textContent = choice.model.color;
            option.selected = selectedColors.has(selectionKey) && choice === entry;
            select.appendChild(option);
          });
          select.addEventListener('change', () => {
            selectedColors.set(selectionKey, select.value);
            entries.forEach(choice => choice.card.classList.toggle('rodier-box-color-hidden', choice.card.dataset.productId !== select.value));
            const next = entries.find(choice => choice.card.dataset.productId === select.value);
            const nextSelect = next?.card.querySelector('.rodier-box-color select');
            if (nextSelect) { nextSelect.value = select.value; nextSelect.focus({preventScroll:true}); }
          });
          label.append(text, select);
          card.querySelector('.gbbProductTextContainer')?.append(label);
        });
      });
    });
  };
  const update = () => {
    scheduled = false;
    groupBundleCards();
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  const start = () => {
    update();
    const root = document.getElementById('main-content');
    if (root) new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    window.addEventListener('popstate', schedule);
    document.addEventListener('shopify:section:load', schedule);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

